import "./index.css";
import { AuthContext } from "../../../context/auth";
import simulatedsService from "../../../services/simulateds.service";
import questionsService from "../../../services/questions.service";
import { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Image } from "react-bootstrap";
import Skeleton from "./Skeleton";
import getModuleIcon from "../../../utils/getModuleIcon";

function Simulated() {
    const auth = useContext(AuthContext);
    const { idSimulated } = useParams();
    const parsedSimulatedId = Number(idSimulated ?? 0);
    const naviget = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [number, setNumber] = useState();
    const [questions, setQuestions] = useState();
    const previousDisabled = number < 1;;
    const nextDisabled = number > 28;
    const isLastQuestion = number === 29;

    useEffect(() => {
        if (parsedSimulatedId <= 0) {
            naviget('/simulados');
            return;
        }

        const loadSimulated = async () => {
            let response = await simulatedsService.get({
                'idSimulated': parsedSimulatedId
            });
            if (response.status === 'success') {
                let simulated = response.data;
                if (simulated.finish !== null) {
                    naviget(`/simulado/${parsedSimulatedId}/resultado`);
                }
                loadQuestions();
            }
            if (response.status === 'error') {
                if (response.error === 'invalid token') {
                    auth.setIsLoggedIn(false);
                }
                naviget('/simulados');
            }
        };

        const loadQuestions = async () => {
            let response = await questionsService.get({
                'idSimulated': parsedSimulatedId
            });
            if (response.status === 'success') {
                let questions = response.data;
                if (questions !== undefined && Object.keys(questions).length > 0) {
                    setQuestions(questions);
                    let lastQuestionAnswered = questions.findIndex(question => question.selectedAnswerId === null);
                    let goOn = (lastQuestionAnswered < 0) ? 29 : lastQuestionAnswered;
                    setNumber(goOn);
                    setIsLoading(false);
                }
            }
            if (response.status === 'error') {  
                if (response.error === 'invalid token') {
                    auth.setIsLoggedIn(false);
                }
                naviget('/simulados');
            }
        };

        loadSimulated();
    }, [parsedSimulatedId, auth, naviget]);

    function isPlateQuestion(question) {
        return question.module?.title === 'Placas, Cores e Caminhos' && question.plate_code;
    }

    const scrollToTop = () => {
        requestAnimationFrame(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    };

    const next = () => {
        setNumber(prev => prev + 1);
        scrollToTop();
    };

    const previous = () => {
        setNumber(prev => prev - 1);
        scrollToTop();
    };

    const updateAnswer = async (selectedAnswerId) => {
        const currentQuestion = questions[number];
        const nextQuestions = questions.map((question, index) => (
            index === number ? { ...question, selectedAnswerId } : question
        ));

        setQuestions(nextQuestions);

        let response = await questionsService.answer({
            'idAnswerSheet': currentQuestion.idAnswerSheet,
            'idSimulated': parsedSimulatedId,
            'idQuestion': currentQuestion.idQuestion,
            'selectedAnswerId': selectedAnswerId
        });

        if (response.status === 'error') {
            if (response.error === 'invalid token') {
                auth.setIsLoggedIn(false);
            }
        }
    };

    const finish = async () => {
        setIsLoading(true);
        let response = await simulatedsService.finish({
            'idSimulated': parsedSimulatedId
        });
        if (response.status === 'success') {
            naviget(`/simulado/${parsedSimulatedId}/resultado`);
        }
        if (response.status === 'error') {
            if (response.error === 'invalid token') {
                auth.setIsLoggedIn(false);
            }
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
            <Skeleton />
        );
    }

    const currentQuestion = questions[number];

    return (
        <div className="simulated-container">
            <div className="question-container">
                <h2 className="m-0">Simulado</h2>
                <div className="fade-effect">
                    <div className="question">
                        <div className="number">PERGUNTA {number + 1}</div>
                        <div className="title">{currentQuestion.question_text}</div>
                        {
                            isPlateQuestion(currentQuestion) && (
                                <div className="image">
                                    <Image src={process.env.PUBLIC_URL + '/assets/plates/' + currentQuestion.plate_code + '.png'} thumbnail />
                                    <div className="code">
                                        {currentQuestion.plate_code}
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
            <div className="alternatives-container">
                <div className="board">
                    <div className="content">
                        {getModuleIcon(currentQuestion.module.title)}
                        <span>
                            <div className="description">
                                {currentQuestion.module.title}
                            </div>
                            <b>
                                {`Questão ${number + 1} de 30`}
                            </b>
                        </span>
                    </div>
                    <div className="options">
                        {
                            currentQuestion.answers.map((alternative, index) => (
                                <div key={index}>
                                    <input
                                        checked={currentQuestion.selectedAnswerId === alternative.id}
                                        className="btn-check"
                                        id={`alternative${alternative.id}`}
                                        name="alternative"
                                        onChange={() => updateAnswer(alternative.id)}
                                        type="radio"
                                        value={alternative.id}
                                    />
                                    <label htmlFor={`alternative${alternative.id}`}>
                                        <span>
                                            {alternative.answer_text}
                                        </span>
                                        <i>
                                            {String.fromCharCode(65 + index)}
                                        </i>
                                    </label>
                                </div>
                            ))
                        }
                    </div>
                    <div className="navegation">
                        <Button bsPrefix="button-navigation" onClick={previous} disabled={previousDisabled}>
                            <svg viewBox="0 0 16 16">
                                <path d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5" />
                            </svg>
                        </Button>
                        {
                            isLastQuestion && (
                                <Button bsPrefix="button-finish" onClick={finish}>
                                    Finalizar
                                </Button>
                            )
                        }
                        <Button bsPrefix="button-navigation" onClick={next} disabled={nextDisabled}>
                            <svg viewBox="0 0 16 16">
                                <path d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                            </svg>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Simulated;
